import { FieldErrors } from 'react-hook-form';

import { NavigationService } from 'services/schemableFormNavigation/schemableFormNavigation';

import { getAllTaskErrors } from './utils';
import { TaskError } from './types';

export class TaskErrorsService extends NavigationService<TaskError> {
  constructor() {
    super();
  }

  focusOnCurrentItem = async (): Promise<void> => {
    //TODO: We don't need the focus on current error functionality. Maybe in the future
    throw new Error('Not needed yet');
  };

  processTaskErrors = (formErrors: FieldErrors, variables: Record<string, string>): void => {
    const errors = getAllTaskErrors(formErrors, variables);
    this.setItems(errors);
  };
}
